<template>
  <div>
    <heading >Application Details</heading>
    <text-field label="First Name" v-model="formFirstName" />
    <text-field label="Last Name" v-model="formLastName" />
    <text-field label="Email" v-model="formEmail" />
    <field label="Resume">
      <p class="control">
        <resume-upload-field v-model="formResume" :is-full-width="true" :uploading="uploading" />
      </p>
    </field>
    <field label="Cover Letter">
      <p class="control">
        <textarea v-model="formCoverLetter" class="textarea" placeholder="Cover letter"></textarea>
      </p>
    </field>
    <checkbox :value="optIn" :changeHandler="optInChangeHandler" label="Opt-in to be considered for other jobs in this company’s network"></checkbox>
  </div>
</template>

<script>
import Heading from '@/components/general/heading'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import ResumeUploadField from '@/components/jobseekers/resume-upload-field-admin'
import Checkbox from '@/components/general/checkbox'
import { mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      uploading: false,
      optIn: false
    }
  },
  components: {Heading, Field, TextField, ResumeUploadField, Checkbox},
  methods: {
    ...mapMutations('RegisterApply', ['setFirstName', 'setLastName', 'setEmail', 'setCoverLetter', 'setResume', 'setSignupBoard']),
    optInChangeHandler (value) {
      this.optIn = value
      this.setSignupBoard(value)
    }
  },
  computed: {
    ...mapState('RegisterApply', ['firstName', 'lastName', 'email', 'coverLetter', 'resume']),
    formFirstName: {
      set (value) {
        this.setFirstName(value)
      },
      get () {
        return this.firstName
      }
    },
    formLastName: {
      set (value) {
        this.setLastName(value)
      },
      get () {
        return this.lastName
      }
    },
    formEmail: {
      set (value) {
        this.setEmail(value)
      },
      get () {
        return this.email
      }
    },
    formCoverLetter: {
      set (value) {
        this.setCoverLetter(value)
      },
      get () {
        return this.coverLetter
      }
    },
    formResume: {
      set (file) {
        this.setResume(file)
      },
      get () {
        return this.resume ? this.resume.name : ''
      }
    },
    optInLabel () {
      return this.$t('widget.optIn')
    }
  }
}
</script>

<style lang="scss" scoped>
  .heading {
    margin-bottom: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/applications/register-and-apply.vue